import { TimelineTimeframes } from 'shared/types/timeline';

export const rowHeight = 38;

export const PLACEHOLDER_DURATIONS_DAYS: Record<TimelineTimeframes, number> = {
  [TimelineTimeframes.Month]: 14,
  [TimelineTimeframes.Quarter]: 28,
  [TimelineTimeframes.Year]: 30,
  [TimelineTimeframes.FiveYears]: 182,
};

// Fraction of a goal row's height (top and bottom) that targets the adjacent
// gap; the band in between is the nest-into-this-goal zone.
export const rowGapBandRatio = 0.25;

// Theme-spacing units the drop line indents per depth level — deliberately
// wider than the rows' own indent so the targeted depth reads clearly.
export const dropLineIndentSpacing = 3;

// Pixels of breathing room left before a bar when an edge arrow scrolls it into
// view, so the bar doesn't land flush against the viewport edge.
export const SCROLL_INTO_VIEW_MARGIN = 80;
